import React from 'react';
import './ChatSystemMessage.scss';
import { MessageView } from '../../../Services/Chat';

function ChatSystemMessage({ message }: { message: MessageView }) {
  return <div className="chat-system-message">{message.message}</div>;
}

export default ChatSystemMessage;
